module.exports = __webpack_public_path__ + "static/media/terms.d89163f3.svg";